import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-domestic-cover',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './domestic-cover.component.html',
  styleUrl: './domestic-cover.component.scss',
})
export class DomesticCoverComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Domestic Travel Insurance Australia | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover offers domestic travel insurance in Australia for cancellations, delays, lost luggage and more. Help protect your next local trip.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Domestic Travel Insurance Australia | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover offers domestic travel insurance in Australia for cancellations, delays, lost luggage and more. Help protect your next local trip.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
